import React, { useState } from 'react';
import './Leaderboard.css';

function Leaderboard({ currentUser }) {
  const [timeframe, setTimeframe] = useState('all');
  const [category, setCategory] = useState('entries');

  // Mock leaderboard data - would come from API
  const leaderboardData = {
    entries: [
      { rank: 1, username: 'Winner123', entries: 1250, wins: 5, avatar: '👑' },
      { rank: 2, username: 'LuckyUser', entries: 980, wins: 3, avatar: '⭐' },
      { rank: 3, username: 'GiveawayKing', entries: 850, wins: 4, avatar: '🎯' },
      { rank: 4, username: 'NitroHunter', entries: 720, wins: 2, avatar: '🎁' },
      { rank: 5, username: 'PrizeSeeker', entries: 650, wins: 1, avatar: '💰' },
      { rank: 6, username: 'EntryMaster', entries: 580, wins: 0, avatar: '📊' },
      { rank: 7, username: 'GiveawayPro', entries: 520, wins: 2, avatar: '🚀' },
      { rank: 8, username: 'NitroFan', entries: 480, wins: 1, avatar: '💎' },
      { rank: 9, username: 'LuckyCharm', entries: 420, wins: 0, avatar: '🍀' },
      { rank: 10, username: 'Winner2024', entries: 380, wins: 1, avatar: '🏆' },
    ],
    wins: [
      { rank: 1, username: 'Winner123', entries: 1250, wins: 5, avatar: '👑' },
      { rank: 2, username: 'GiveawayKing', entries: 850, wins: 4, avatar: '🎯' },
      { rank: 3, username: 'LuckyUser', entries: 980, wins: 3, avatar: '⭐' },
      { rank: 4, username: 'NitroHunter', entries: 720, wins: 2, avatar: '🎁' },
      { rank: 5, username: 'GiveawayPro', entries: 520, wins: 2, avatar: '🚀' },
    ],
  };

  const data = leaderboardData[category] || leaderboardData.entries;
  const currentUserRank = currentUser ? data.findIndex(u => u.username === currentUser.discordUsername) + 1 : null;

  return (
    <div className="leaderboard-page">
      <div className="leaderboard-container">
        <div className="leaderboard-header">
          <h1>🏆 Leaderboard</h1>
          <p>Top performers on NitroDrop</p>
        </div>

        <div className="leaderboard-controls">
          <div className="control-group">
            <label>Category:</label>
            <select value={category} onChange={(e) => setCategory(e.target.value)}>
              <option value="entries">Most Entries</option>
              <option value="wins">Most Wins</option>
            </select>
          </div>
          <div className="control-group">
            <label>Timeframe:</label>
            <select value={timeframe} onChange={(e) => setTimeframe(e.target.value)}>
              <option value="all">All Time</option>
              <option value="month">This Month</option>
              <option value="week">This Week</option>
            </select>
          </div>
        </div>

        {currentUser && currentUserRank && (
          <div className="user-rank-card">
            <div className="user-rank-info">
              <span className="user-rank-number">#{currentUserRank}</span>
              <div>
                <h3>{currentUser.discordUsername}</h3>
                <p>{data[currentUserRank - 1]?.entries || 0} entries</p>
              </div>
            </div>
          </div>
        )}

        <div className="leaderboard-list">
          <div className="leaderboard-header-row">
            <span>Rank</span>
            <span>User</span>
            <span>Entries</span>
            <span>Wins</span>
            <span>Badge</span>
          </div>
          {data.map((user, index) => (
            <div
              key={user.rank}
              className={`leaderboard-item ${user.rank <= 3 ? 'top-three' : ''} ${currentUser && user.username === currentUser.discordUsername ? 'current-user' : ''}`}
            >
              <div className="rank-badge">
                {user.rank === 1 && '🥇'}
                {user.rank === 2 && '🥈'}
                {user.rank === 3 && '🥉'}
                {user.rank > 3 && `#${user.rank}`}
              </div>
              <div className="user-info">
                <span className="user-avatar">{user.avatar}</span>
                <span className="username">{user.username}</span>
              </div>
              <div className="stat-value">{user.entries.toLocaleString()}</div>
              <div className="stat-value">{user.wins}</div>
              <div className="user-badge">
                {user.rank === 1 && '👑 Champion'}
                {user.rank === 2 && '⭐ Elite'}
                {user.rank === 3 && '🎯 Pro'}
                {user.rank > 3 && '—'}
              </div>
            </div>
          ))}
        </div>

        <div className="leaderboard-footer">
          <p>Leaderboard updates in real-time</p>
          <p>Rankings are based on total entries and wins</p>
        </div>
      </div>
    </div>
  );
}

export default Leaderboard;

